module.exports = __webpack_public_path__ + "img/development (4).d8618385.png";